// extracted by mini-css-extract-plugin
module.exports = {"logs-table":"OutletActivityLogs_logs-table__3AWbN"};